import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { AvaliacaoAula } from 'src/app/models/avaliacao-aula';
import { AulaService } from 'src/app/services/aula/aula.service';
import { Location } from '@angular/common';
import { TipoAvaliacao } from 'src/app/models/tipo-avaliacao';
import { TipoIdentificacao } from 'src/app/models/tipo-identificacao';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MessageUtil } from 'src/app/utils/message.util';
import { ToastrService } from 'ngx-toastr';
import { camelCase } from 'lodash';

@Component({
  selector: 'app-avaliacao-aula',
  templateUrl: './avaliacao-aula.component.html',
  styleUrls: ['./avaliacao-aula.component.scss'],
})
export class AvaliacaoAulaComponent implements OnInit {
  @BlockUI() blockUI: NgBlockUI;
  formGroup: FormGroup;
  id: number;
  nome: string;
  avaliacaoAula = new AvaliacaoAula();
  tiposAvaliacao = [];
  tiposIdentificacao = [];

  constructor(
    private activatedRoute: ActivatedRoute,
    private location: Location,
    private formBuilder: FormBuilder,
    private aulaService: AulaService,
    private toastr: ToastrService,
    private router: Router
  ) {}

  ngOnInit() {
    this.activatedRoute.params.subscribe((params) => {
      if (params['id'] > 0) {
        this.iniciarAvaliacao(params.id);
        this.getAvaliacao();
      } else {
        this.location.back();
      }
    });
  }

  iniciarAvaliacao(id: number) {
    this.id = id;
    this.getAula();
    this.getTiposAvaliacao();
    this.getTiposIdentificacao();
    this.criarFormGroup();
  }

  getAvaliacao() {
    this.aulaService.getAvaliacao(this.id).subscribe(
      (avaliacaoAula) => {
        this.blockUI.stop();
        this.avaliacaoAula.tipoAvaliacao = this.tiposAvaliacao.find(
          (t) => t.id === camelCase(avaliacaoAula.tipoAvaliacao)
        );
        this.avaliacaoAula.tipoIdentificacao = this.tiposIdentificacao.find(
          (t) => t.id === camelCase(avaliacaoAula.tipoIdentificacao)
        );
        this.avaliacaoAula.comentario = avaliacaoAula.comentario;
        this.formGroup.disable();
      },
      () => this.blockUI.stop()
    );
  }

  getAula() {
    this.blockUI.start(MessageUtil.AGUARDE);
    this.aulaService.getPreAula(this.id).subscribe(
      (aula) => {
        this.blockUI.stop();
        this.nome = aula.nome;
      },
      (err) => {
        this.blockUI.stop();
        this.toastr.error(err.error.message || 'Não foi possível obter a aula para avaliação, tente novamente.');
        this.location.back();
      }
    );
  }

  getTiposAvaliacao() {
    this.tiposAvaliacao = Object.keys(TipoAvaliacao).map((key) => {
      return {
        id: key,
        nome: TipoAvaliacao[key],
      };
    });
  }

  getTiposIdentificacao() {
    this.tiposIdentificacao = Object.keys(TipoIdentificacao).map((key) => {
      return {
        id: key,
        nome: TipoIdentificacao[key],
      };
    });
  }

  criarFormGroup() {
    this.formGroup = this.formBuilder.group({
      tipoAvaliacao: ['', [Validators.required]],
      tipoIdentificacao: ['', [Validators.required]],
      comentario: ['', [Validators.maxLength(500)]],
    });
  }

  salvarAvaliacaoAula() {
    if (this.formGroup.invalid) {
      this.toastr.error(MessageUtil.PREENCHA_CAMPOS_OBRIGATORIOS);
      return;
    }

    this.blockUI.start(MessageUtil.AGUARDE);
    this.aulaService.salvarAvaliacao(this.id, this.avaliacaoAula).subscribe(
      () => {
        this.blockUI.stop();
        this.toastr.success('Aula avaliada com sucesso!');
        this.router.navigate(['/sala-de-aula', this.id]);
      },
      (err) => {
        this.blockUI.stop();
        this.toastr.error(err.error.message || 'Não foi possível avaliar a aula, tente novamente.');
      }
    );
  }
}
